import React from 'react';
import { SectionLayout } from '@/components/shared/section-layout';

export function ProjectManagementPage() {
  return (
    <SectionLayout title="Project Management" />
  );
} 